/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';

const Footer = () => {
  return (
    <>
      {/* --- Main Footer Section --- */}
      <div className="bg-footer">
        <div className="container">
          <div className="row py-10">
            <div className="flex justify-center items-center">
              <img src={require("../images/logo.png")} alt="Steminorder Logo" />
            </div>
          </div>

          <div className="row pb-5">
            <div className="flex justify-center items-center space-x-3">
              <a className="footer-icons rounded-circle border" href="https://facebook.com" target="_blank" rel="noreferrer">
                <i className="bi bi-facebook"></i>
              </a>
              <a className="footer-icons rounded-circle border" href="https://twitter.com" target="_blank" rel="noreferrer">
                <i className="bi bi-twitter-x"></i>
              </a>
              <a className="footer-icons rounded-circle border" href="https://instagram.com" target="_blank" rel="noreferrer">
                <i className="bi bi-instagram"></i>
              </a>
              <a className="footer-icons rounded-circle border" href="https://youtube.com" target="_blank" rel="noreferrer">
                <i className="bi bi-youtube"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* --- Copyright + Legal Links --- */}
      <div className="bg-footer-2">
        <div className="container">
          <div className="flex flex-col md:flex-col justify-center items-center text-center md:space-x-4 text-white py-3 text-sm">
            <p>© {new Date().getFullYear()} Steminorder. All rights reserved.</p>
            <div className="flex m-0">
              <a href="/terms-of-service" className="text-gray-300 hover:text-white transition-colors">
                Terms of Service
              </a>
              <span>|</span>
              <a href="/privacy-policy" className="text-gray-300 hover:text-white transition-colors">
                Privacy Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
